<template>
  <div v-if="!!basicData" class="px-1 px-md-5">
    <p v-if="$i18n.locale === 'CH'">
      {{ basicData.companyDescriptionCh }}
    </p>
    <p v-if="$i18n.locale === 'EN'">
      {{ basicData.companyDescriptionEn }}
    </p>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  props: ["basicData"],
};
</script>

<style scoped>
p {
  padding-top: 10px;
  padding-right: 25px;
  padding-left: 25px;
  font-size: 20px;
}
</style>
